module.exports = __webpack_public_path__ + "static/mm-scroll-c9b9576e2fe996e844271ac6835eeaee.gif";